import { AlertCircle } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { useReveal } from "../../hooks/useReveal";
import { errorText } from "../../lib/validate";

export const VERTICAL_KEYS = ["agro", "mines", "petrole", "numerique"];
export const VCOLOR = { agro: "var(--agro)", mines: "var(--mines)", petrole: "var(--petrole)", numerique: "var(--numerique)" };
export const VTEXT = { agro: "var(--agro)", mines: "var(--mines)", petrole: "var(--rust-text)", numerique: "var(--numerique-text)" };

export const LogoMark = () => (
  <span className="logo-mark" aria-hidden="true">
    <svg viewBox="15 10 160 160" xmlns="http://www.w3.org/2000/svg">
      <path d="M45,15 H145 L170,40 V140 L145,165 H45 L20,140 V40 Z" fill="#1B242E" stroke="#E8A93A" strokeWidth="3" />
      <path d="M38,88 L58,88 L66,73 L76,103 L86,88 L98,88 L106,78 L116,98 L126,88 L152,88" fill="none" stroke="#5BC8D6" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <text x="95" y="128" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fontSize="24" fill="#F4F5F6">IH</text>
    </svg>
  </span>
);

export const Section = ({ id, eyebrow, title, desc, children, testid }) => {
  const ref = useReveal();
  return (
    <section id={id} className="section" data-testid={testid}>
      <div className="wrap reveal" ref={ref}>
        <div className="section-head">
          <p className="eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
          {desc && <p className="desc">{desc}</p>}
        </div>
        {children}
      </div>
    </section>
  );
};

export const Field = ({ id, label, error, span2, required, children }) => {
  const { t } = useLang();
  const msg = errorText(t, error);
  return (
    <div className={`f-field${span2 ? " f-span2" : ""}`}>
      <label htmlFor={id}>{label}{required && <span className="req" aria-hidden="true">*</span>}</label>
      {children}
      {msg && (
        <span className="f-error" id={`${id}-error`} role="alert" data-testid={`${id}-error`}>
          <AlertCircle aria-hidden="true" /> {msg}
        </span>
      )}
    </div>
  );
};

export const inputProps = (id, error, required) => ({
  id,
  className: "f-input",
  "aria-invalid": error ? "true" : "false",
  "aria-describedby": error ? `${id}-error` : undefined,
  "aria-required": required ? "true" : undefined,
  "data-testid": `${id}-input`,
});

export const OptionList = ({ map, withEmpty }) => {
  const { t } = useLang();
  return (
    <>
      {withEmpty && <option value="">{t.common.select}</option>}
      {Object.entries(map).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
    </>
  );
};

export const ExampleBadge = () => {
  const { t } = useLang();
  return <span className="ex-badge">{t.common.example}</span>;
};
